










































import { Component } from "vue-property-decorator";
import { Step } from "@/components/infrastructures/molecules/StepContents.vue";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import BackBtn from "@/components/infrastructures/atoms/designed/BackBtn.vue";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import {PurchaseGetterTypes} from "@/store/product/purchase/types";
import ProductService from "@/components/domains/products/productService";
import SubscriptionService from "@/components/domains/payment/shared/subscription/SubscriptionService";

@Component({
  components: {
    PrimaryBtn,
    BackBtn,
  }
})
export default class ContractStep extends Step {

  name = "ContractStep";
  loading = false;
  product = null;

  mounted() {
    this.getProduct.then(product => this.product = product);
  }

  get getProduct() {
    const productId = this.$store.getters[PurchaseGetterTypes.getProductId];
    return ProductService.fetchProduct(productId);
  }

  async goToStripe() {
    // ユーザー操作直下で window を確保
    const win = window.open("", "_self");
    this.loading = true;
    try {

      const productId = (await this.getProduct).id
      const url = await SubscriptionService.fetchSubscribeUrl(productId);

      // 後から URL を差し替える
      win!.location.href = url;

    } catch (e) {
      alert("決済画面への遷移に失敗しました。");
      this.loading = false;
    }
  }

  public doCancel() {
    super.doCancel();
  }

  public getComponentName(): string {
    return this.name;
  }

  public getStepTitle(): string {
    return "お支払い";
  }
}
